import { isEmpty } from 'lodash';
import { replace } from 'redux-first-router';

import { querySel } from '@location';
import { MbcMessagingPage } from '@modules/messaging/components/MbcMessagingPage/MbcMessagingPage';
import { emptyObj } from '@shared';
import {
  ROUTE_MESSAGING,
  organizationPositionsSel,
  setOrganization,
} from '@shared/duck';
import {
  ROUTE_BALANCE_MESSAGING,
  ROUTE_MBC_MESSAGING,
} from '@shared/duck/actionsTyped';
import { newPermissions } from '@shared/newPermissions';

import { BalanceMessagingPage, MessagingPage } from './components';

const routes = {
  [ROUTE_MESSAGING]: {
    path: '/messaging',
    Component: MessagingPage,
    titleId: 'page.messaging',
    permission: newPermissions.VIEW_MESSAGING,
    thunk: (dispatch, getState) => {
      const state = getState();
      const positions = organizationPositionsSel(state);
      const { organizationGuid = '' } = querySel(state) || emptyObj;

      if (!isEmpty(organizationGuid) && !isEmpty(positions)) {
        const foundedPosition = positions.find(
          p => p.organizationGuid === organizationGuid,
        );
        replace('/messaging');
        if (foundedPosition) {
          dispatch(
            setOrganization({
              guid: foundedPosition.organizationGuid,
              programType: foundedPosition.programType,
              parentOrgGuid: foundedPosition.organizationGuid,
            }),
          );
        }
      }
    },
  },
  [ROUTE_BALANCE_MESSAGING]: {
    path: '/balance-messaging',
    Component: BalanceMessagingPage,
    titleId: 'page.balanceMessaging',
    permission: newPermissions.VIEW_MESSAGING,
  },
  [ROUTE_MBC_MESSAGING]: {
    path: '/mbc-messaging',
    Component: MbcMessagingPage,
    titleId: 'page.mbcMessaging',
    permission: newPermissions.VIEW_MESSAGING,
  },
};

export default routes;
